import React from "react";
import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { DeepInsightDocumentContent } from "@/types/deep-insights.ts";
import ReactMarkdown from "react-markdown";

const styles = StyleSheet.create({
  page: { padding: 60 },
  title: { fontSize: 18, fontWeight: "bold", marginBottom: 24 },
  section: { marginBottom: 16 },
  sectionTitle: { fontSize: 12, fontWeight: "bold", marginBottom: 8 },
  chart: { width: "100%", height: 250, marginTop: 24 },
  paragraph: { fontSize: 12, marginBottom: 6, lineHeight: 1.5 },
  bold: { fontWeight: "bold" },
  listItem: { fontSize: 12, marginLeft: 12, marginBottom: 4 },
});

interface DeepInsightPDFProps {
  report: DeepInsightDocumentContent;
  chartImage: string | null;
}

const DeepInsightPDF: React.FC<DeepInsightPDFProps> = ({
  report,
  chartImage,
}) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>{report.title}</Text>

        {report.sections.map((section) => (
          <View key={section.title} style={styles.section}>
            <Text style={styles.sectionTitle}>{section.title}</Text>

            <ReactMarkdown
              components={{
                p: ({ children }) => (
                  <Text style={styles.paragraph}>{children}</Text>
                ),
                strong: ({ children }) => (
                  <Text style={styles.bold}>{children}</Text>
                ),
                li: ({ children }) => (
                  <Text style={styles.listItem}>• {children}</Text>
                ),
                ul: ({ children }) => <View>{children}</View>,
                ol: ({ children }) => <View>{children}</View>,
              }}
            >
              {section.content}
            </ReactMarkdown>
          </View>
        ))}

        {chartImage && <Image src={chartImage} style={styles.chart} />}
      </Page>
    </Document>
  );
};

export default DeepInsightPDF;
